import { Sparkles, Target, Zap } from 'lucide-react';
import { Card } from '@/components/ui/card';

export const AboutSection = () => {
  const benefits = [
    {
      icon: Sparkles,
      title: 'It’s so simple to use',
      description: 'You’ll be up and running in hours, not weeks. Fewer clicks, less training, more time for meaningful work.',
    },
    {
      icon: Target,
      title: 'AI that actually helps',
      description: 'From onboarding to appraisals, hirerkey™ automates repetitive tasks. HR teams save 40+ hours per month and accomplish more with fewer resources.',
    },
    {
      icon: Zap,
      title: 'Enterprise features at 75% lower cost',
      description: 'All the enterprise-grade tools you expect—making high-end technology easily affordable for everyone.',
    },
  ];

  return (
    <section className="py-8 sm:py-10 md:py-12 bg-gradient-subtle">
      <div className="max-w-[745px] w-full mx-auto px-4 sm:px-6">
        <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-10 animate-fade-in">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-3 sm:mb-4">
            hirerkey<sup className="text-base sm:text-lg">™</sup> is Different From Others
          </h2>
          <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
            We believe the workplace should <span className="emphasize font-semibold text-foreground">work for people</span>. hirerkey<sup>™</sup> reshapes how organizations manage, 
            engage, and empower their workforce—creating workplaces where people <span className="emphasize-accent font-semibold text-foreground">flourish</span>.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <Card
                key={index}
                className="p-4 sm:p-6 hover-lift bg-card border-2 border-border/50 hover:border-primary/30 transition-colors animate-fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-3 sm:mb-4">
                  <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-primary" />
                </div>
                <h3 className="text-sm sm:text-base font-bold mb-2">{benefit.title}</h3>
                <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                  {benefit.description}
                </p>
              </Card>
            );
          })}
        </div>

        {/* Stats */}
        <div className="mt-8 sm:mt-10 md:mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
          {[
            { label: 'Platform Modules', value: '12+' },
            { label: 'Employee Touchpoints', value: '50+' },
            { label: 'Go-Live Time', value: '3 Days' },
            { label: 'UAE-First Platform', value: 'AED' },
          ].map((stat, index) => (
            <div
              key={index}
              className="relative animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Background layer */}
              <div className="absolute inset-0 bg-dark-section rounded-lg translate-x-0.5 translate-y-0.5"></div>
              
              {/* Main card */}
              <div className="relative text-center p-3 sm:p-4 rounded-lg bg-gradient-to-r from-blue-500/10 via-purple-500/10 to-teal-500/10 border border-white/10">
                <div className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-1">
                  {stat.value}
                </div>
                <div className="text-[10px] sm:text-xs text-gray-300 font-medium">
                  {stat.label}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
